import { useState } from "react";
import axios from "axios";

export default function AdminLogin({ setToken }) {
  const [form, setForm] = useState({ username: "", password: "" });
  const [error, setError] = useState("");

  // Handle input change
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  // Handle form submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // Call backend login API (proxy handles localhost:5000)
      const res = await axios.post("/api/admin/login", form);

      // Save token in localStorage
      localStorage.setItem("token", res.data.token);

      // Update parent App.js state
      setToken(res.data.token);
    } catch (err) {
      setError("Invalid username or password");
    }
  };

  return (
    <div className="container my-5">
      <div className="card shadow p-4 mx-auto" style={{ maxWidth: "400px" }}>
        <h2 className="mb-4 fw-bold text-center text-dark">Admin Login</h2>

        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <input
              name="username"
              placeholder="Username"
              className="form-control"
              value={form.username}
              onChange={handleChange}
              required
            />
          </div>

          <div className="mb-3">
            <input
              name="password"
              type="password"
              placeholder="Password"
              className="form-control"
              value={form.password}
              onChange={handleChange}
              required
            />
          </div>

          <button type="submit" className="btn btn-gold w-100 fw-bold">
            Login
          </button>
        </form>

        {error && (
          <div className="alert alert-danger mt-3 text-center">{error}</div>
        )}
      </div>
    </div>
  );
}


